import React from 'react';
import {
  Grid,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Link,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import { makeStyles } from '@material-ui/core/styles';
import commonStyles from '../../styles';
import EmptyAlert from './emptyAlert';
import { URL_MAPPER } from '../../../constants/urls';
import LineReceptionCustomer from './lineReceptionCustomer';
import { getEnvVariable } from '../../../commonFunction/getEnv';

const useStyles = makeStyles((theme) => ({
  accordion: {
    backgroundColor: '#F3F3F3',
    '& .MuiAccordionDetails-root': {
      display: 'block',
      padding: 0,
    },
  },
  bodyContent: {
    '& .MuiTable-root': {
      background: '#fff',
      border: 'solid 1px C8C8C8',
    },
  },
  tableContainer: {
    maxHeight: 147,
    border: 'solid 1px #C8C8C8',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    '& .material-icons': {
      color: '#D83420',
      fontSize: 18,
    },
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 5,
  },
  headerLinkTxt: {
    color: theme.palette.primaryColor,
  },
  buttonFlex: {
    display: 'flex',
    flexDirection: 'flex-start',
    '& .MuiAccordionSummary-root': {
      padding: 0,
      minHeight: 0,
      '& .MuiAccordionSummary-content': {
        margin: 0,
      },
    },
    '& .MuiIconButton-root': {
      padding: 0,
      '& .MuiIconButton-label': {
        color: theme.palette.primaryColor,
      },
    },
    '& .MuiIconButton-edgeEnd': {
      marginRight: 0,
    },
  },
  toggleButton: {
    padding: 0,
    textAlign: 'left',
    display: 'block',
    minWidth: 10,
  },
  tableHead: {
    '& th': {
      backgroundColor: '#fff',
    },
  },
  headerCell: {
    color: '#8C8C8C',
    textAlign: 'center',
    borderBottom: 'solid 2px #C8C8C8',
    padding: '12px 0 6px 0',
  },
  bodyTableRow: {
    '&:nth-of-type(even)': {
      backgroundColor: '#F3F3F3',
    },
    '& td': {
      fontSize: 13,
      textAlign: 'center',
      padding: '5px 0',
    },
    '&:hover': {
      background: `${theme.palette.primaryColor}29!important`,
    },
  },
  telAndMailCell: {
    width: '4%',
  },
}));

const headerCells = [
  { id: 'number', label: 'No' },
  { id: 'lastReceivedAt', label: '受信日時' },
  { id: 'customer', label: '顧客' },
  { id: 'lileLink', label: 'LINEリンク' },
  { id: 'user', label: '担当' },
];

function LineReceptionList(props) {
  const { dataList } = props;
  const isLoading = dataList?.isLoading;
  const classes = useStyles();
  const baseClasses = commonStyles();
  const { lineReceptions = [], total = 0 } = dataList?.data || {};

  const tableBody = (
    <TableBody>
      {lineReceptions.map((data, index) => {
        const { lastReceivedAt, customer, user } = data;

        return (
          <TableRow
            className={classes.bodyTableRow}
            style={data.telCount === 0 || data.mailCount === 0 ? { backgroundColor: 'rgba(216, 52, 32, 0.08)' } : {}}
            key={String(index)}
            hover
          >
            <TableCell style={{ width: '5%' }}>
              {index + 1}
            </TableCell>
            <TableCell style={{ width: '20%' }}>
              {lastReceivedAt}
            </TableCell>
            <TableCell style={{ width: '30%', maxWidth: 0 }}>
              <LineReceptionCustomer
                id={customer.id}
                fullName={customer.fullName || ''}
                memberStatus={customer.memberStatusCode}
                customerStatus={customer.status}
                memberId={customer.memberId}
              />
            </TableCell>
            <TableCell style={{ width: '25%' }}>
              <Link
                href={getEnvVariable('LINE_URL') + customer.hashCustomerId}
                target="_blank"
                color="primary"
              >
                LINEリンク
              </Link>
            </TableCell>
            <TableCell style={{ width: '20%' }}>
              {user}
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  );
  const body = (
    <TableContainer className={`${classes.tableContainer} dashbordScrollArea`}>
      <Table stickyHeader aria-label="sticky table">
        <TableHead className={classes.tableHead}>
          <TableRow>
            {headerCells.map((headerCell) => (
              <TableCell
                className={`${baseClasses.title4} ${classes.headerCell} nowrap`}
                key={headerCell.id}
              >
                {headerCell.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        {!isLoading && tableBody}
      </Table>
      {isLoading ? (
        <EmptyAlert>データ取得中...</EmptyAlert>
      ) : (
        !total && <EmptyAlert>0件</EmptyAlert>
      )}
    </TableContainer>
  );
  return (
    <Accordion
      className={classes.accordion}
      defaultExpanded
    >
      <Grid className={classes.headerContainer}>
        <Grid className={classes.buttonFlex}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className={classes.toggleButton} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          />
          <Grid className={classes.buttonContainer}>
            <Typography className={baseClasses.title3}>
              LINE受信一覧 ({total})
            </Typography>
          </Grid>
        </Grid>
        <Grid>
          <Link href={`${URL_MAPPER.line_reception}`}>
            <Typography className={`${baseClasses.smallStrong} ${classes.headerLinkTxt}`}>
              LINE受信一覧で表示
            </Typography>
          </Link>
        </Grid>
      </Grid>
      <AccordionDetails>
        <Grid className={classes.bodyContent}>
          {body}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}

export default LineReceptionList;
